import React, { ReactElement } from 'react';

import { MessageType } from '@savgroup-front-common/types';

import { Heading } from '../../atoms/Heading';
import { SafeFormattedMessageWithoutSpread } from '../../formatters';
import { useIsNewUiEnabled } from '../../hooks/useIsNewUiEnabled';

import { $ContentCol, $Row, $TitleCol } from './SummarySection.styles';

interface SummarySectionProps {
  title?: MessageType;
  image?: ReactElement;
  fluid?: boolean;
}

export const SummarySection: React.FC<
  React.PropsWithChildren<SummarySectionProps>
> = ({ title, children, image, fluid }) => {
  const isNewUiEnabled = useIsNewUiEnabled();

  const hasTitle = image || title;

  if (isNewUiEnabled) {
    return (
      <$Row>
        {hasTitle && (
          <$TitleCol>
            {image ||
              (title && <SafeFormattedMessageWithoutSpread message={title} />)}
          </$TitleCol>
        )}
        <$ContentCol $fluid={fluid}>{children}</$ContentCol>
      </$Row>
    );
  }

  return (
    <>
      <Heading level={2}>
        {image ||
          (title && <SafeFormattedMessageWithoutSpread message={title} />)}
      </Heading>
      <div>{children}</div>
    </>
  );
};
